export default {
  form: {
    should_save_payment_info: {
      label: 'Betaalgegevens opslaan voor sneller afrekenen',
    },
  },
};
